import { Check } from "lucide-react";

export const Step4Review = ({ t, displayName, upn, f, summary }) => (
  <div className="space-y-4" data-testid="onboard-review">
    <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-zinc-600"><Check size={15} /> {t("onboard.summary")}</div>
    <div>
      <div className="text-xs font-bold uppercase tracking-wider text-zinc-400">{t("onb.newAccount")}</div>
      <div className="mt-1 text-base font-semibold text-zinc-900">{displayName || "—"}</div>
      <div className="font-mono text-xs text-primary">{upn}</div>
      <div className="mt-2 grid grid-cols-2 gap-x-6 gap-y-1 text-sm text-zinc-600 sm:grid-cols-3">
        {f.givenName && <div><span className="text-zinc-400">{t("field.givenName")}: </span>{f.givenName}</div>}
        {f.surname && <div><span className="text-zinc-400">{t("field.surname")}: </span>{f.surname}</div>}
        {f.jobTitle && <div><span className="text-zinc-400">{t("field.jobTitle")}: </span>{f.jobTitle}</div>}
        {f.department && <div><span className="text-zinc-400">{t("field.department")}: </span>{f.department}</div>}
        {f.companyName && <div><span className="text-zinc-400">{t("field.company")}: </span>{f.companyName}</div>}
        {f.managerName && <div><span className="text-zinc-400">{t("field.manager")}: </span>{f.managerName}</div>}
        {f.streetAddress && <div><span className="text-zinc-400">{t("field.street")}: </span>{f.streetAddress}</div>}
        {f.postalCode && <div><span className="text-zinc-400">{t("field.zip")}: </span>{f.postalCode}</div>}
        {f.city && <div><span className="text-zinc-400">{t("field.city")}: </span>{f.city}</div>}
        {f.description && <div className="col-span-2 sm:col-span-3"><span className="text-zinc-400">{t("field.description")}: </span>{f.description}</div>}
      </div>
    </div>
    <div className="grid grid-cols-1 gap-4 border-t border-zinc-100 pt-4 sm:grid-cols-2 lg:grid-cols-3">
      {[[t("onb.sumApps"), summary.apps], [t("onb.sumGroups"), summary.groups], [t("onb.sumDistribution"), summary.dls], [t("onb.sumLicenses"), summary.licenses], [t("onb.sumTeams"), summary.teams], [t("roles.sharedMailboxes"), summary.shared]].map(([ti, arr]) => (
        <div key={ti}>
          <div className="text-xs font-bold uppercase tracking-wider text-zinc-400">{ti} ({arr.length})</div>
          <div className="mt-1 space-y-0.5">
            {arr.length === 0 ? <span className="text-sm text-zinc-300">{t("common.none")}</span> : arr.map((n, i) => <div key={`${n}-${i}`} className="text-sm text-zinc-700">• {n}</div>)}
          </div>
        </div>
      ))}
    </div>
    <div className="border-t border-zinc-200 pt-3 font-mono text-[11px] text-zinc-400">{t("onb.runsLabel")} <span className="text-zinc-700">createUser → on-prem groups → wait for sync → cloud resources</span></div>
  </div>
);
